export default __webpack_public_path__ + "static/media/menuToggler.a2c26930.svg";